import React from 'react';
import { NavLink } from 'react-router-dom';

const AdminNavigation = () => {
  const adminLinks = [
    { path: '/admin', name: 'Dashboard', icon: '📊', end: true },
    { path: '/admin/products', name: 'Products', icon: '🛍️' },
    { path: '/admin/orders', name: 'Orders', icon: '📦' },
    { path: '/admin/users', name: 'Users', icon: '👥' },
    { path: '/admin/coupons', name: 'Coupons', icon: '🎫' },
    { path: '/admin/messages', name: 'Messages', icon: '💬' },
    { path: '/admin/delete-requests', name: 'Requests', icon: '🗑️' }
  ];

  return (
    <>
      {/* Mobile Navigation */}
      <div className="lg:hidden w-full bg-white border-b border-warm-gray/20 overflow-x-auto sticky top-16 md:top-20 z-40 no-scrollbar">
        <nav className="flex p-2 gap-2 min-w-max">
          {adminLinks.map((link) => (
            <NavLink
              key={link.path}
              to={link.path}
              end={link.end}
              className={({ isActive }) => `
                flex items-center gap-2 px-3 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap
                ${isActive
                  ? 'bg-deep-brown text-gold shadow-sm'
                  : 'bg-white text-warm-gray border border-warm-gray/20'
                }
              `}
            >
              <span>{link.icon}</span>
              <span>{link.name}</span>
            </NavLink>
          ))}
        </nav>
      </div>

      {/* Desktop Sidebar */}
      <aside className="w-64 bg-white shadow-xl min-h-[calc(100vh-5rem)] flex-shrink-0 border-r border-warm-gray/20 hidden lg:block sticky top-16 md:top-20 h-[calc(100vh-4rem)] md:h-[calc(100vh-5rem)] overflow-y-auto">
        <div className="p-6 border-b border-warm-gray/10">
          <h2 className="text-xl font-serif font-bold text-deep-brown">Admin Panel</h2>
          <p className="text-xs text-warm-gray mt-1">Manage your store</p>
        </div>
        <nav className="p-4 space-y-1">
          {adminLinks.map((link) => (
            <NavLink
              key={link.path}
              to={link.path}
              end={link.end}
              className={({ isActive }) => `
                flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200 group
                ${isActive
                  ? 'bg-deep-brown text-gold shadow-md'
                  : 'text-warm-gray hover:bg-cream hover:text-deep-brown'
                }
              `}
            >
              <span className="text-xl group-hover:scale-110 transition-transform duration-200">{link.icon}</span>
              <span className="font-medium text-sm tracking-wide">{link.name}</span>
            </NavLink>
          ))}
        </nav>
      </aside>
    </>
  );
};

export default AdminNavigation;